<script lang="ts" setup>
type Anchor = 'bottom left' | 'end' | 'start' | 'left' | 'right'

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  isShow: {
    type: Boolean,
    default: true,
  },
  isImage: {
    type: Boolean,
    default: false,
  },
  customClass: {
    type: String,
    default: '',
  },
  location: {
    type: String as PropType<Anchor>,
    default: 'end',
  },
  role: {
    type: String,
    required: false,
    default: undefined,
  },
})

const emit = defineEmits(['click', 'close'])

const onUpdate = (value: boolean) => {
  if (!value) {
    emit('close')
  }
}
const { EVENT_ENABLE } = useRuntimeConfig().public
const slots = useSlots()
</script>
<template>
  <VTooltip
    v-if="props.isShow"
    :text="props.text"
    :class="props.customClass"
    :location="props.location"
    :aria-label="props.text"
    @update:model-value="onUpdate"
  >
    <template #activator="{ props: tooltipProps }">
      <div
        class="base-tooltip"
        v-bind="{
          ...tooltipProps,
          'aria-describedby': undefined,
        }"
        @click="emit('click')"
      >
        <img
          v-if="isImage"
          class="img-entry-event-collapse"
          :src="
            EVENT_ENABLE
              ? '/images/event-drawing-lots/img-san-sieu-hu-collapse.webp'
              : '/images/top-winning/img-san-sieu-hu-collapse.webp'
          "
          alt="entry event"
        />
        <slot v-else />
      </div>
    </template>

    <div v-if="slots.content">
      <slot name="content" />
    </div>
    <span v-else>{{ text }}</span>
  </VTooltip>
  <slot v-else />
</template>
